export const StatutsAcdemat = {
  EN_PREPARATION: {nom: 'EN_PREPARATION', ordre: 1},
  DEPOSE: {nom: 'DEPOSE', ordre: 10},
  EN_INSTRUCTION: {nom: 'EN_INSTRUCTION', ordre: 20},
  EN_SYNTHESE: {nom: 'EN_SYNTHESE', ordre: 30},
  DECIDE: {nom: 'DECIDE', ordre: 40},
  SUIVI_CHANTIER: {nom: 'SUIVI_CHANTIER', ordre: 50},
  MISE_EN_SERVICE: {nom: 'MISE_EN_SERVICE', ordre: 60},
  FIN_DOSSIER: {nom: 'FIN_DOSSIER', ordre: 70},
  ANNULE: {nom: 'ANNULE', ordre: 80}
}
